import React, { Component } from 'react';
import { Layout, Button, Row, Col, Popconfirm, Spin, Affix } from 'antd';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LoadingBar from 'react-redux-loading-bar';

const { Header, Content, Footer } = Layout;

export default class AdminLayout extends Component {

  static propTypes = {
    back: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func
    ]),
    buttons: PropTypes.array,
    title: PropTypes.string,
  };

  button = (button, index) => {
    if (button.confirmation)
      return (<Popconfirm key={index} placement="bottomLeft" title={"Voulez-vous continuer ?"} onConfirm={button.onClick} okText="Oui" cancelText="Non">
        <Button
          style={{ margin: '0 5px' }}
          type={button.type ? button.type : 'primary'}
          icon={button.icon}
          loading={button.loading ? button.loading : false}
          disabled={button.disabled ? button.disabled : false}
          key={"buttonHeader_" + index}
        >
          {button.name}
        </Button>
      </Popconfirm>)
    else
      return (
        button.link ?
          <Link key={index} to={button.link}>
            <Button
              style={{ margin: '0 5px' }}
              onClick={button.onClick}
              type={button.type ? button.type : 'primary'}
              icon={button.icon}
              loading={button.loading ? button.loading : false}
              disabled={button.disabled ? button.disabled : false}
              key={"buttonHeader_" + index}
            >
              {button.name}
            </Button>
          </Link>
          :
          <Button
            style={{ margin: '0 5px' }}
            onClick={button.onClick}
            type={button.type ? button.type : 'primary'}
            icon={button.icon}
            loading={button.loading ? button.loading : false}
            disabled={button.disabled ? button.disabled : false}
            key={"buttonHeader_" + index}
          >
            {button.name}
          </Button>
      )
  }

  render() {
    return (
      <div className="admin-admin-layout">
        <Affix offsetTop={0}>
          <Header className="header-admin-layout" style={{ background: '#fff', height: '64px', padding: '0' }}>
            <Row>
              <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '64px', padding: 0 }} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 2 }} lg={{ span: 1 }}>
                {typeof this.props.back === "function" ?

                  <a onClick={this.props.back}>
                    <Button type="primary" icon="left" size="large" />
                  </a>

                  : this.props.back ?
                  <Link to={this.props.back}>
                    <Button type="primary" icon="left" size="large" />
                  </Link>
                  :
                  ''
                }
              </Col>
              <Col className="title-admin-layout" style={{ padding: "0 16px", lineHeight: '64px' }} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10 }} lg={{ span: 8 }}>
                {this.props.title.toUpperCase()}
              </Col>
              <Col style={{ padding: "0 16px" }} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 15 }}>
                <Row className="button-content-admin-layout" style={{ padding: '15px 0 0 0' }}>
                  {this.props.loading ?
                    <Spin size="small" />
                    :
                    (this.props.buttons ?
                      this.props.buttons.map((button, index) => this.button(button, index))
                      :
                      '')
                  }
                </Row>
              </Col>
            </Row>
            <LoadingBar className="loading-bar"/>
          </Header>
        </Affix>
        <Content className="content-admin-layout" style={{ margin: "0 16px" }}>
          {this.props.loading ?
            <div style={{ textAlign: 'center', padding: '30px 50px', margin: '20px 0' }}><Spin /></div>
            :
            this.props.children
          }
        </Content>
        <Footer className="footer-admin" >
              Ynov Planner
        </Footer>
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/admin/AdminLayout.js